module.exports = __webpack_public_path__ + "img/thumb_12.230cb12d.jpg";